<template>
    <div class="lesson-panel">
        <h1>款式定制操作流程</h1>
        <h4>从设计稿到成衣，在这里轻松实现</h4>
        <video ref="videoplayer"
               src="https://img.hongli.xingjuju.com/yichuanghub/template/20260414/fd2c0a59410a732971692dbb2d70e0b13ec2a070.mp4"
               class="video" poster="https://img.hongli.xingjuju.com/yichuanghub/template/20260414/fd2c0a59410a732971692dbb2d70e0b13ec2a070.mp4?x-oss-process=video/snapshot,t_1000,m_fast"
               controls loop preload="auto"
               style="width: 85%; max-width: 1000px;height:100%;" @timeupdate="onVideoTimeUpdate">
            Your browser does not support the video tag.
        </video>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: "Lesson",
        data() {
            return {
            }
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                videoCurrentTime: (state) => state.design.videoCurrentTime,
                is_lesson_show:(state)=>state.design.is_lesson_show
            }),
        },
        mounted() {
            // 设置视频播放时间
            this.$nextTick(() => {
                if(this.$refs.videoplayer){
                    this.$refs.videoplayer.currentTime = this.videoCurrentTime;
                }
            });
        },
        methods: {
            onVideoTimeUpdate() {
                // 更新视频播放时间
                if(this.$refs.videoplayer){
                    this.$store.commit('design/update_video_current_time', this.$refs.videoplayer.currentTime);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

    .lesson-panel {
        display:flex;
        align-items:center;
        justify-content:center;
        flex-direction:column;
        h1 {
            // margin-top: 120px;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            text-align: center;
        }
        h4 {
            margin-top: 15px;
            font-size: 14px;
            color: #999999;
            text-align: center;
        }
        video {
            margin-top: 50px;
        }
    }


</style>
